import type { Block } from 'payload';

export const CALLOUT_BLOCK_SLUG = 'callout';

export const CALLOUT_VARIANTS = [
  { label: 'Information', value: 'info' },
  { label: 'Warning', value: 'warning' },
  { label: 'Action needed', value: 'action' },
] as const;

export const calloutBlock: Block = {
  slug: CALLOUT_BLOCK_SLUG,
  interfaceName: 'Callout',
  labels: {
    singular: 'Callout',
    plural: 'Callouts',
  },
  fields: [
    {
      name: 'variant',
      type: 'select',
      required: true,
      defaultValue: 'info',
      options: [...CALLOUT_VARIANTS],
    },
    {
      name: 'content',
      type: 'textarea',
      required: true,
      maxLength: 320,
    },
  ],
};
